import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, toggleFormatter, defaultColumnId, booleanFormatter } from '@Components/Grid/utils/column';

import EntityTipFormatter from './EntityTipFormatter'

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('path', {
      header: 'Description',
      cell: info => <NameAndCreateDateFormatter info={info} link={false} />,
      initialSize: 'max-w-[20vw]',
    }),
    column.accessor('entity', {
      header: 'Entity',
      cell: info => <EntityTipFormatter info={info} />,
      enableTruncateTooltip: true,
    }),
    defaultColumn('content_type', 'Type', undefined, { enableTruncateTooltip: true }),
    defaultColumn('is_custom', 'Custom Route', booleanFormatter, { enableColumnResize: false }),
    defaultColumn('is_config', 'Config Route', booleanFormatter, { enableColumnResize: false }),
    defaultColumn('is_home', 'Is Home', toggleFormatter, { enableColumnResize: false }),
  ], [])
}
